import React from 'react';
import PropTypes from 'prop-types';
import { NoValue } from '../NoValue';
import Decimal from './Decimal';

export const NullableDecimal = ({ value, className, noValueClasses }) => {
  return value ? (
    <Decimal fixedDecimalScale value={value} className={className} />
  ) : (
    <NoValue classes={noValueClasses} />
  );
};

NullableDecimal.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
  noValueClasses: PropTypes.object
};

export default NullableDecimal;
